import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";






const Reports = ({ currentUser }) => {
  const [reportName, setReportName] = useState("");
  const [centerName, setCenterName] = useState("");
  const [product, setProduct] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [campaign, setCampaign] = useState("");
  const [leadSource, setLeadSource] = useState("");

  const [reportData, setReportData] = useState([]);
  const [products, setProducts] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [leadSources, setLeadSources] = useState([]);
  const [centers, setCenters] = useState([]);
  const [loading, setLoading] = useState(false);
   const [ loading1, setLoading1] = useState(false);

  // ✅ Load dropdown data
  useEffect(() => {
    axios.get("https://crm-server-htk6.vercel.app/api/products")
      .then(res => setProducts(res.data))
      .catch(err => console.error("❌ Products:", err));

    axios.get("https://crm-server-htk6.vercel.app/api/campaigns")
      .then(res => setCampaigns(res.data))
      .catch(err => console.error("❌ Campaigns:", err));

    axios.get("https://crm-server-htk6.vercel.app/api/leadSources")
      .then(res => setLeadSources(res.data))
      .catch(err => console.error("❌ LeadSources:", err));

    axios.get("https://crm-server-htk6.vercel.app/api/centers")
      .then(res => setCenters(res.data || []))
      .catch(err => console.error("❌ Centers:", err));
  }, []);

 


//   const handleExportExcel = async () => {
//   if (!reportData || reportData.length === 0) {
//     alert("No data to export!");
//     return;
//   }

//   try {
//     setLoading(true); // ✅ Start Loading

//     await new Promise((resolve) => setTimeout(resolve, 200));

//     const exportRows = reportData.map((row, index) => {
//       const v = row.transferredVerifier || {};

//       return {
//         ID: row._id, // ✅ Replace _id with formatted index
//         FirstName: row.firstName || "",
//         MiddleName: row.middleName || "",
//         LastName: row.lastName || "",
//         DOB:  row.dob || "",
//         Gender: row.gender || "",
//         Email: row.email || "",
//         Phone: row.phone || "",
//         AlternatePhone: row.alternatePhone || "",
//         Address: row.address || "",
//         City: row.city || "",
//         State: row.state || "",
//         Zip: row.zip || "",
//     CardNumber: row.cardNumber ? `'${row.cardNumber.replace(/-/g, "")}` : "",

//         Expiry: row.expiry || "",
//         CVV: row.cvv || "",
//         BankName: row.bankName || "",
//         BankAddress: row.bankAddress || "",
//         RoutingNumber: row.routingNumber || "",
//         AccountNumber: row.accountNumber || "",
//         LeadSource: row.leadSource || "",
//       Product: row.product ? row.product.replace(/\s+/g, "") : "",

//         VerifierEmpCode: v.empCode || "",
//         VerifierName: `${v.firstName || ""} ${v.lastName || ""}`.trim(),
//          verifCode: row.verifCode || "",
//               trackId: row.trackId || "",
//         CenterName: row.centerName || "",
//         AgentName: row.agentName || "",
//         Campaign: row.campaign || "",
//         Disposition: row.disposition || "",
//         Comments: row.comments || "",
//       VerifiedDate: row.verifiedDate || "",
// SubmittedDate: row.submittedDate || "",


//       };
//     });

//     const worksheet = XLSX.utils.json_to_sheet(exportRows);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "CustomerData");

//     const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

//     saveAs(blob, `CustomerData_${new Date().toISOString()}.xlsx`);
//   } catch (err) {
//     console.error("❌ Excel Export Error:", err);
//     alert("Failed to export Excel. Check console for details.");
//   } finally {
//     setLoading(false); // ✅ Stop Loading
//   }
// };

const handleExportExcel = async () => {
  if (!reportData || reportData.length === 0) {
    alert("No data to export!");
    return;
  }

  try {
    setLoading(true);

    await new Promise((resolve) => setTimeout(resolve, 200));

    const exportRows = reportData.map((row, index) => {
      const v = row.transferredVerifier || {};
 const PRODUCT_ORDER = ["BSID", "MT", "PC", "SC", "FRP", "MRP", "MD", "ID", "MRS", "DMY", "DMY_C"];
      return {
        ID: row._id,
        FirstName: row.firstName || "",
        MiddleName: row.middleName || "",
        LastName: row.lastName || "",
        DOB: row.dob || "",
        Gender: row.gender || "",
        Email: row.email || "",
        Phone: row.phone || "",
        AlternatePhone: row.alternatePhone || "",
        Address: row.address || "",
        City: row.city || "",
        State: row.state || "",
        Zip: row.zip || "",
        CardNumber: row.cardNumber ? `'${row.cardNumber.replace(/-/g, "")}` : "",
        Expiry: row.expiry ? `'${row.expiry}` : "",

        CVV: row.cvv || "",
        BankName: row.bankName || "",
        BankAddress: row.bankAddress || "",
        RoutingNumber: row.routingNumber || "",
        AccountNumber: row.accountNumber || "",
        LeadSource: row.leadSource || "",
     

Product:
  row.product
    ? row.product
        .replace(/\s+/g, "")          // remove spaces
        .split(",")                   // split into array
        .filter(Boolean)              // remove empty
        .sort(
          (a, b) =>
            PRODUCT_ORDER.indexOf(a) - PRODUCT_ORDER.indexOf(b)
        )                             // order by your sequence
        .join(",")                    // join back
    : "",

        VerifierEmpCode: v.empCode || "",
        VerifierName: `${v.firstName || ""} ${v.lastName || ""}`.trim(),
        verifCode: row.verifCode || "",
        trackId: row.trackId || "",
        CenterName: row.centerName || "",
        AgentName: row.agentName || "",
        Campaign: row.campaign || "",
        Disposition: row.disposition || "",
        Comments: row.comments || "",
        VerifiedDate: row.verifiedDate || "",
        SubmittedDate: row.submittedDate || "",
      };
    });

    // Convert to worksheet
    const worksheet = XLSX.utils.json_to_sheet(exportRows);

    // Convert worksheet to CSV
    const csvData = XLSX.utils.sheet_to_csv(worksheet);

    // Save as CSV file
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `CustomerData_${new Date().toISOString()}.csv`);

  } catch (err) {
    console.error("❌ CSV Export Error:", err);
    alert("Failed to export CSV. Check console for details.");
  } finally {
    setLoading(false);
  }
};



const [allowedReports, setAllowedReports] = useState([]); // ✅ List of reports allowed
const [, setMappingExists] = useState(false); // ✅ ignore value, keep setter



useEffect(() => {
  if (!currentUser?.center || !currentUser?.role) return;

  setLoading1(true);
  axios
    .get(
      `https://crm-server-htk6.vercel.app/api/report-mapping?center=${encodeURIComponent(
        currentUser.center
      )}&role=${encodeURIComponent(currentUser.role)}`
    )
    .then((res) => {
      if (res.data) {
        setMappingExists(true);
        setAllowedReports(res.data.reports || []);
      } else {
        setMappingExists(false);
        setAllowedReports([]);
      }
    })
    .catch((err) => console.error("❌ Error fetching report mapping:", err))
    .finally(() => setLoading1(false));
}, [currentUser, setMappingExists]); // ✅ dependency array

const [phone, setPhone] = useState("");

  // ✅ Fetch & build report
  const fetchReport = async () => {
     try {
    setLoading1(true);

    // -------------------------------------
    // 1️⃣ BUILD QUERY PARAMETERS FOR BACKEND
    // -------------------------------------
    const params = new URLSearchParams();
if (phone) params.append("phone", phone);

    if (centerName) params.append("centerName", centerName);
    if (product) params.append("product", product);
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (campaign) params.append("campaign", campaign);
    if (leadSource) params.append("leadSource", leadSource);

    console.log("📌 Query Sent:", params.toString());

    // -------------------------------------
    // 2️⃣ FETCH FILTERED DATA DIRECTLY
    // -------------------------------------
    const agentsRes = await axios.get(
      `https://crm-server-htk6.vercel.app/api/agents1?${params.toString()}`
    );

    let filtered = agentsRes.data || [];
    console.log("📌 Filtered Data Returned From Backend:", filtered);


if (reportName === "Agent Sales Report") {
  const grouped = {};

  filtered.forEach((a) => {
    const name = a.agentName || "Unknown";

    if (!grouped[name]) {
      grouped[name] = {
        call: 0,      // total calls (forms)
        sales: 0,     // total sales
        products: 0   // total products (only for sales)
      };
    }

    // 📞 Count each form as a call
    grouped[name].call += 1;

    // 💰 Count sales + products (only when sale)
    if ((a.disposition || "").toString().trim().toLowerCase() === "sale") {
      grouped[name].sales += 1;

      // 📦 Count products for sales only
      const productField = a.product || "";
      const productCount = productField
        .split(",")
        .map((p) => p.trim())
        .filter((p) => p.length > 0).length;

      grouped[name].products += productCount;
    }
  });

  // ➡️ Prepare final rows
  setReportData(
    Object.keys(grouped).map((agentName) => {
      const g = grouped[agentName];
      const conv =
        g.call > 0 ? ((g.sales / g.call) * 100).toFixed(2) : "0.00";
      const ratio =
        g.sales > 0 ? (g.products / g.sales).toFixed(2) : "0.00";
      return {
        agentName,
        call: g.call,
        sales: g.sales,
        conv,
        products: g.products,
        ratio
      };
    })
  );
}


else if (reportName === "Verif Sales Report") {
  const grouped = {};
  const dispositionSamples = new Set(); // optional debug

  filtered.forEach((a) => {
    const v = a.transferredVerifier || {};
    const verifName = `${v.firstName || ""} ${v.lastName || ""}`.trim() || "Unknown";
    const empCode = v.empCode || "N/A";
    const key = empCode + "|" + verifName;

    if (!grouped[key]) {
      grouped[key] = {
        empCode,
        verifName,
        transfer: 0,   // same as callToken
        sales: 0,
        products: 0,
      };
    }

    // ➕ Count each call/transfer
    grouped[key].transfer += 1;

    // 💰 Sales check (robust)
    const d = a.disposition;
    let s = "";
    if (d) {
      s = typeof d === "string"
        ? d.trim().toLowerCase()
        : typeof d === "object"
          ? String(d.status || d.value || d.name || d.label || "").trim().toLowerCase()
          : "";
    }

    if (s === "sale") {
      grouped[key].sales += 1;

      // 📦 Count products only when sale
      const productField = a.product || "";
      const productCount = String(productField)
        .split(",")
        .map((p) => p.trim())
        .filter((p) => p.length > 0).length;

      grouped[key].products += productCount;
    }

    dispositionSamples.add(s);
  });

  // Prepare final rows
  const rows = Object.keys(grouped).map((k) => {
    const g = grouped[k];
    const conv = g.transfer > 0 ? ((g.sales / g.transfer) * 100).toFixed(2) : "0.00";
    const ratio = g.sales > 0 ? (g.products / g.sales).toFixed(2) : "0.00";
    return {
      empCode: g.empCode,
      verifName: g.verifName,
      transfer: g.transfer,
      sales: g.sales,
      conv,
      products: g.products,
      ratio,
    };
  });

  setReportData(rows);

  // optional debug
  if (dispositionSamples.size > 0) {
    console.debug("Verifier dispositions:", Array.from(dispositionSamples).slice(0, 50));
  }
}

else if (reportName === "Verif Product Report") {
  const grouped = {};

  filtered.forEach((a) => {
    const v = a.transferredVerifier || {};
    const empCode = v.empCode || "N/A";
    const fullName = `${v.firstName || ""} ${v.lastName || ""}`.trim() || "Unknown";
    const key = empCode + "|" + fullName;

    if (!grouped[key]) {
      const productCounts = {};
      products.forEach((p) => (productCounts[p.productName] = 0));
      grouped[key] = {
        empCode,
        fullName,
        productCounts,
        totalProduct: 0, // count of products sold (only for sale)
        totalSale: 0,
        totalTransfer: 0, // optional, if you want parity with Verif Sales Report
      };
    }

    // 🧮 robust disposition check (same logic as Verif Sales Report)
    const d = a.disposition;
    const s =
      typeof d === "string"
        ? d.trim().toLowerCase()
        : typeof d === "object"
        ? String(d.status || d.value || d.name || d.label || "").trim().toLowerCase()
        : "";

    // count each call (optional)
    grouped[key].totalTransfer += 1;

    // 💰 Only count products when disposition is 'sale'
    if (s === "sale") {
      grouped[key].totalSale += 1;

      const productField = a.product || a.productName || "";
      const productList = String(productField)
        .split(",")
        .map((p) => p.trim())
        .filter((p) => p);

      productList.forEach((prod) => {
        if (grouped[key].productCounts[prod] !== undefined) {
          grouped[key].productCounts[prod] += 1;
          grouped[key].totalProduct += 1;
        }
      });
    }
  });

  // 🧾 Prepare final report data
  setReportData(
    Object.values(grouped).map((r) => ({
      ...r,
      productCon:
        r.totalTransfer > 0
          ? ((r.totalSale / r.totalTransfer) * 100).toFixed(2)
          : "0.00", // Conversion = Sales / Transfers
      ratio:
        r.totalSale > 0
          ? (r.totalProduct / r.totalSale).toFixed(2)
          : "0.00", // Ratio = Products / Sales
    }))
  );
}


else if (reportName === "Center Product Report") {
  const grouped = {};

  filtered.forEach((a) => {
    const center = a.centerName || "Unknown";

    if (!grouped[center]) {
      const productCounts = {};
      products.forEach((p) => (productCounts[p.productName] = 0));
      grouped[center] = {
        centerName: center,
        productCounts,
        totalProduct: 0,
        totalSale: 0,
      };
    }

    // 🧮 Robust disposition check (same as Verif Sales Report)
    const d = a.disposition;
    const s =
      typeof d === "string"
        ? d.trim().toLowerCase()
        : typeof d === "object"
        ? String(d.status || d.value || d.name || d.label || "").trim().toLowerCase()
        : "";

    // 🏷️ Count products (always)
    const productField = a.product || a.productName || "";
    const productList = productField
      .split(",")
      .map((p) => p.trim())
      .filter((p) => p);

    productList.forEach((prod) => {
      if (grouped[center].productCounts[prod] !== undefined) {
        grouped[center].productCounts[prod] += 1;
        grouped[center].totalProduct += 1;
      }
    });

    // 💰 Count sale once per record (not per product)
    if (s === "sale") {
      grouped[center].totalSale += 1;
    }
  });

  // 🧾 Prepare final output rows
  setReportData(
    Object.values(grouped).map((r) => ({
      ...r,
      productCon:
        r.totalProduct > 0
          ? ((r.totalSale / r.totalProduct) * 100).toFixed(2)
          : "0.00",
      ratio:
        r.totalSale > 0
          ? (r.totalProduct / r.totalSale).toFixed(2)
          : "0.00", // ➕ Ratio = Total Products / Total Sales
    }))
  );
}



else if (reportName === "Agent Wise Center Sales Performance Report") {
  const grouped = {};

  filtered.forEach(a => {
    const center = a.centerName || "Unknown";

    if (!grouped[center]) {
      grouped[center] = {
        centerName: center,
        calls: 0,
        sales: 0,
        products: 0,
        agents: new Set(), // To track unique agents
      };
    }

    // ➕ Count every call
    grouped[center].calls += 1;

    // ➕ Count sales (case-insensitive)
    if ((a.disposition || "").toLowerCase() === "sale") {
      grouped[center].sales += 1;
    }

    // ➕ Count products (comma separated)
    const productField = a.product || a.productName || "";
    const productList = productField
      .split(",")
      .map(p => p.trim())
      .filter(p => p);

    grouped[center].products += productList.length;

    // ➕ Track unique agents for HC
    if (a.agentName) grouped[center].agents.add(a.agentName);
  });

  // ✅ Prepare final data array
  setReportData(
    Object.values(grouped).map(r => {
      const headCount = r.agents.size;
      const sales = r.sales;
      const calls = r.calls;
      const products = r.products;

      return {
        centerName: r.centerName,
        calls,
        sales,
        conv: calls > 0 ? ((sales / calls) * 100).toFixed(2) : "0.00",
        products,
        ratio: sales > 0 ? (products / sales).toFixed(2) : "0.00",
        headCount,
        avgSale: sales > 0 ? (headCount / sales).toFixed(2) : "0.00",
        avgProduct: headCount > 0 ? (products / headCount).toFixed(2) : "0.00",
      };
    })
  );
}

else if (reportName === "Verifier Wise Center Sales Performance Report") {
  const grouped = {};

  filtered.forEach(a => {
    const center = a.centerName || "Unknown";
    const v = a.transferredVerifier || {};
    const verifName = `${v.firstName || ""} ${v.lastName || ""}`.trim() || "Unknown";

    if (!grouped[center]) {
      grouped[center] = {
        centerName: center,
        calls: 0,
        sales: 0,
        products: 0,
        verifiers: new Set(), // ➡️ Track unique verifiers
      };
    }

    // ➕ Count every call for that center
    grouped[center].calls += 1;

    // ➕ Count sales (case-insensitive)
    if ((a.disposition || "").toLowerCase() === "sale") {
      grouped[center].sales += 1;
    }

    // ➕ Count products (comma separated)
    const productField = a.product || a.productName || "";
    const productList = productField
      .split(",")
      .map(p => p.trim())
      .filter(p => p);

    grouped[center].products += productList.length;

    // ➕ Track unique verifiers for HC
    if (verifName && verifName !== "Unknown") {
      grouped[center].verifiers.add(verifName);
    }
  });

  // ✅ Prepare final data array
  setReportData(
    Object.values(grouped).map(r => {
      const headCount = r.verifiers.size;
      const sales = r.sales;
      const calls = r.calls;
      const products = r.products;

      return {
        centerName: r.centerName,
        calls,
        sales,
        conv: calls > 0 ? ((sales / calls) * 100).toFixed(2) : "0.00",
        products,
        ratio: sales > 0 ? (products / sales).toFixed(2) : "0.00",
        headCount,
        avgSale: sales > 0 ? (headCount / sales).toFixed(2) : "0.00",
        avgProduct: headCount > 0 ? (products / headCount).toFixed(2) : "0.00",
      };
    })
  );
}


else if (reportName === "Agent Wise Leader Performance Report") {
  try {
    // ✅ Fetch all users to map agents → TL
    const userRes = await axios.get("https://crm-server-htk6.vercel.app/api/users");
    const users = userRes.data || [];

    // 🔑 Build a mapping of agentName → tlName
    const agentToTL = {};
    users.forEach(u => {
      const agentFullName = `${u.firstName || ""} ${u.lastName || ""}`.trim();
      const tlName = u.tlName || "Unknown";
      if (agentFullName) agentToTL[agentFullName] = tlName;
    });

    const grouped = {};

    // ✅ Go through all filtered forms
    filtered.forEach(a => {
      const agentName = a.agentName || "Unknown";
      const tlName = agentToTL[agentName] || "Unassigned";

      if (!grouped[tlName]) {
        grouped[tlName] = {
          leader: tlName,
          calls: 0,
          sales: 0,
          products: 0,
          agents: new Set(), // ➡️ Unique agents for HC
        };
      }

      // ➕ Calls
      grouped[tlName].calls += 1;

      // ➕ Sales
      if ((a.disposition || "").toLowerCase() === "sale") {
        grouped[tlName].sales += 1;
      }

      // ➕ Products
      const productField = a.product || a.productName || "";
      const productList = productField
        .split(",")
        .map(p => p.trim())
        .filter(p => p);

      grouped[tlName].products += productList.length;

      // ➕ Unique agents
      if (agentName && agentName !== "Unknown") {
        grouped[tlName].agents.add(agentName);
      }
    });

    // ✅ Finalize computed fields
    setReportData(
      Object.values(grouped).map(r => {
        const headCount = r.agents.size;
        const calls = r.calls;
        const sales = r.sales;
        const products = r.products;

        return {
          leader: r.leader,
          calls,
          sales,
          conv: calls > 0 ? ((sales / calls) * 100).toFixed(2) : "0.00",
          products,
          ratio: sales > 0 ? (products / sales).toFixed(2) : "0.00",
          headCount,
          avgSale: sales > 0 ? (headCount / sales).toFixed(2) : "0.00",
          avgProduct: headCount > 0 ? (products / headCount).toFixed(2) : "0.00",
        };
      })
    );
  } catch (err) {
    console.error("❌ Error fetching TL Performance:", err);
    setReportData([]);
  }
}

else if (reportName === "Verifier Wise Leader Performance Report") {
  try {
    // ✅ Fetch all users to map verifiers → TL
    const userRes = await axios.get("https://crm-server-htk6.vercel.app/api/users");
    const users = userRes.data || [];

    // 🔑 Build a mapping of verifierName → tlName
    const verifierToTL = {};
    users.forEach(u => {
      const verifierFullName = `${u.firstName || ""} ${u.lastName || ""}`.trim();
      const tlName = u.tlName || "Unknown";
      if (verifierFullName) verifierToTL[verifierFullName] = tlName;
    });

    const grouped = {};

    // ✅ Go through all filtered forms
    filtered.forEach(a => {
      const v = a.transferredVerifier || {};
      const verifierName = `${v.firstName || ""} ${v.lastName || ""}`.trim() || "Unknown";
      const tlName = verifierToTL[verifierName] || "Unassigned";

      if (!grouped[tlName]) {
        grouped[tlName] = {
          leader: tlName,
          calls: 0,
          sales: 0,
          products: 0,
          verifiers: new Set(), // ➡️ Unique verifiers for HC
        };
      }

      // ➕ Calls
      grouped[tlName].calls += 1;

      // ➕ Sales
      if ((a.disposition || "").toLowerCase() === "sale") {
        grouped[tlName].sales += 1;
      }

      // ➕ Products
      const productField = a.product || a.productName || "";
      const productList = productField
        .split(",")
        .map(p => p.trim())
        .filter(p => p);

      grouped[tlName].products += productList.length;

      // ➕ Unique verifiers
      if (verifierName && verifierName !== "Unknown") {
        grouped[tlName].verifiers.add(verifierName);
      }
    });

    // ✅ Finalize computed fields
    setReportData(
      Object.values(grouped).map(r => {
        const headCount = r.verifiers.size;
        const calls = r.calls;
        const sales = r.sales;
        const products = r.products;

        return {
          leader: r.leader,
          calls,
          sales,
          conv: calls > 0 ? ((sales / calls) * 100).toFixed(2) : "0.00",
          products,
          ratio: sales > 0 ? (products / sales).toFixed(2) : "0.00",
          headCount,
          avgSale: sales > 0 ? (headCount / sales).toFixed(2) : "0.00",
          avgProduct: headCount > 0 ? (products / headCount).toFixed(2) : "0.00",
        };
      })
    );
  } catch (err) {
    console.error("❌ Error fetching Verifier TL Performance:", err);
    setReportData([]);
  }
}



      // ✅ Customer Data report
      else if (reportName === "Customer Data") {
        // Simply show filtered raw data
        setReportData(filtered);
      }

      else {
        setReportData([]);
      }
    } catch (err) {
      console.error("❌ Error fetching report:", err);
    } finally {
      setLoading1(false);
    }
  };


  // Compute summary for current report
const getSummary = () => {
  if (!reportData || reportData.length === 0) return null;

  let summary = {};

  if (reportName === "Agent Sales Report") {
    const totalCalls = reportData.reduce((a, b) => a + (b.call || 0), 0);
    const totalSales = reportData.reduce((a, b) => a + (b.sales || 0), 0);
    const totalProducts = reportData.reduce((a, b) => a + (b.products || 0), 0);
    const avgConv = totalCalls > 0 ? ((totalSales / totalCalls) * 100).toFixed(2) : "0.00";
    const avgRatio = totalSales > 0 ? (totalProducts / totalSales).toFixed(2) : "0.00";

    summary = {
      label: "TOTAL / AVG",
      totalCalls,
      totalSales,
      totalProducts,
      avgConv,
      avgRatio,
    };
  }

else if (reportName === "Verif Product Report") {

  const productTotals = {};
  products.forEach((p) => {
    productTotals[p.productName] = 0;
  });

  reportData.forEach((row) => {
    products.forEach((p) => {
      productTotals[p.productName] += row.productCounts?.[p.productName] || 0;
    });
  });

  const totalSale = reportData.reduce((a, b) => a + (b.totalSale || 0), 0);
  const totalProducts = reportData.reduce((a, b) => a + (b.totalProduct || 0), 0);
  const totalTransfer = reportData.reduce((a, b) => a + (b.totalTransfer || 0), 0);

  const avgConv =
    totalTransfer > 0 ? ((totalSale / totalTransfer) * 100).toFixed(2) : "0.00";

  const avgRatio =
    totalSale > 0 ? (totalProducts / totalSale).toFixed(2) : "0.00";

  summary = {
    label: "TOTAL / AVG",
    productTotals,
    totalSale,
    totalProducts,
    totalTransfer,
    avgConv,
    avgRatio,
  };
}

  

  else if (reportName === "Verif Sales Report") {
    const totalTransfer = reportData.reduce((a, b) => a + (b.transfer || 0), 0);
    const totalSales = reportData.reduce((a, b) => a + (b.sales || 0), 0);
    const totalProducts = reportData.reduce((a, b) => a + (b.products || 0), 0);
    const avgConv = totalTransfer > 0 ? ((totalSales / totalTransfer) * 100).toFixed(2) : "0.00";
    const avgRatio = totalSales > 0 ? (totalProducts / totalSales).toFixed(2) : "0.00";

    summary = {
      label: "TOTAL / AVG",
      totalTransfer,
      totalSales,
      totalProducts,
      avgConv,
      avgRatio,
    };
  }

  else if (
    reportName === "Agent Wise Center Sales Performance Report" ||
    reportName === "Verifier Wise Center Sales Performance Report" ||
    reportName === "Agent Wise Leader Performance Report" ||
    reportName === "Verifier Wise Leader Performance Report"
  ) {
    const totalCalls = reportData.reduce((a, b) => a + (b.calls || 0), 0);
    const totalSales = reportData.reduce((a, b) => a + (b.sales || 0), 0);
    const totalProducts = reportData.reduce((a, b) => a + (b.products || 0), 0);
    const totalHC = reportData.reduce((a, b) => a + (b.headCount || 0), 0);
    const avgConv = totalCalls > 0 ? ((totalSales / totalCalls) * 100).toFixed(2) : "0.00";
    const avgRatio = totalSales > 0 ? (totalProducts / totalSales).toFixed(2) : "0.00";
    const avgHC = reportData.length > 0 ? (totalHC / reportData.length).toFixed(2) : "0.00";
    const avgSale = totalSales > 0 ? (totalHC / totalSales).toFixed(2) : "0.00";
    const avgProduct = totalHC > 0 ? (totalProducts / totalHC).toFixed(2) : "0.00";

    summary = {
      label: "TOTAL / AVG",
      totalCalls,
      totalSales,
      totalProducts,
      avgConv,
      avgRatio,
      avgHC,
      avgSale,
      avgProduct,
    };
  }

  // Add more report types if needed
  return summary;
};

  
  return (
    <div className="page">

    {loading && (
  <div className="loading-overlay">
    <div className="spinner"></div>
    ⏳ Exporting ...
  </div>
)}
    {loading1 && (
  <div className="loading-overlay">
    <div className="spinner"></div>
    ⏳ Fetching ...
  </div>
)}


      <h2>Reports</h2>
      {allowedReports.length === 0 && (
  <p style={{ color: "red", marginTop: "10px" }}>
    ⚠️ You do not have access to any reports for this center/role.
  </p>
)}

      {/* 🔹 Filter Bar */}
      <div className="filter-bar" style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "20px" }}>
       <select
  value={reportName}
  onChange={(e) => setReportName(e.target.value)}
  disabled={allowedReports.length === 0} // disable if no reports allowed
>
  <option value="">Select Report</option>
  {allowedReports.map((rep, idx) => (
    <option key={idx} value={rep}>
      {rep}
    </option>
  ))}
</select>


<input
  type="text"
  placeholder="Phone"
  value={phone}
  onChange={(e) => setPhone(e.target.value)}
  style={{ padding: "6px" }}
/>



        <select value={centerName} onChange={(e) => setCenterName(e.target.value)}>
          <option value="">Select Center</option>
          {centers.map(c => (
            <option key={c._id} value={c.centerName}>{c.centerName}</option>
          ))}
        </select>

        <select value={product} onChange={(e) => setProduct(e.target.value)}>
          <option value="">Select Product</option>
          {products.map(p => (
            <option key={p._id} value={p.productName}>{p.productName}</option>
          ))}
        </select>

        <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
        <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

        <select value={campaign} onChange={(e) => setCampaign(e.target.value)}>
          <option value="">Select Campaign</option>
          {campaigns.map(c => (
            <option key={c._id} value={c.campaignName}>{c.campaignName}</option>
          ))}
        </select>

        <select value={leadSource} onChange={(e) => setLeadSource(e.target.value)}>
          <option value="">Select Lead Source</option>
          {leadSources.map(ls => (
            <option key={ls._id} value={ls.name}>{ls.name}</option>
          ))}
        </select>

        <button onClick={fetchReport}>Go</button>

       {reportName === "Customer Data" && (
  <button
    onClick={handleExportExcel}
    className="export-btn"
    style={{
      background: "#27ae60",
      color: "#fff",
      padding: "8px 16px",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      marginLeft: "10px",
      fontWeight: 500,
    }}
  >
    Export to Excel
  </button>
)}



      </div>

      {/* 🔹 Table */}
      {loading ? (
        <p>Loading report...</p>
      ) : (
        <div className="table-container1" style={{ marginTop: "20px", overflowX: "auto" }} >
  <table className="report-table table-container" style={{ borderCollapse: "collapse", width: "100%" }} >

            <thead>
             {reportName === "Agent Sales Report" && (
  <tr style={{ background: "#2c3e50", color: "#fff" }}>
    <th>Agent Name</th>
    <th>Call</th>
    <th>Sales</th>
    <th>Conv (%)</th>
    <th>Products</th>
    <th>Ratio (Prod/Sales)</th>
  </tr>
)}


              {reportName === "Verif Sales Report" && (
  <tr>
    <th>Employee Code</th>
    <th>Verifier Name</th>
    <th>Transfer</th>
    <th>Sales</th>
    <th>Conv (%)</th>
    <th>Products</th>
    <th>Ratio</th>
  </tr>
)}


             {reportName === "Verif Product Report" && (
  <tr>
    <th>Emp Code</th>
    <th>Emp Name</th>
    {products.map((p) => (
      <th key={p._id}>{p.productName}</th>
    ))}
    <th>Total Product</th>
    <th>Total Sale</th>
    <th>Product Con (%)</th>
    <th>Ratio</th> {/* ➕ New column */}
  </tr>
)}

{reportName === "Center Product Report" && (
  <tr>
    <th>Center Name</th>
    {products.map((p) => (
      <th key={p._id}>{p.productName}</th>
    ))}
    <th>Total Product</th>
    <th>Total Sale</th>
    <th>Product Con (%)</th>
    <th>Ratio</th>
  </tr>
)}

{reportName === "Agent Wise Center Sales Performance Report" && (
  <tr>
    <th>Center</th>
    <th>Calls</th>
    <th>Sales</th>
    <th>Conversion (%)</th>
    <th>Products</th>
    <th>Ratio</th>
    <th>Head Count (HC)</th>
    <th>Avg Sale</th>
    <th>Avg Product</th>
  </tr>
)}

{reportName === "Verifier Wise Center Sales Performance Report" && (
  <tr>
    <th>Center</th>
    <th>Calls</th>
    <th>Sales</th>
    <th>Conversion (%)</th>
    <th>Products</th>
    <th>Ratio</th>
    <th>Head Count (HC)</th>
    <th>Avg Sale</th>
    <th>Avg Product</th>
  </tr>
)}

{reportName === "Agent Wise Leader Performance Report" && (
  <tr>
    <th>Leader</th>
    <th>Calls</th>
    <th>Sales</th>
    <th>Conversion (%)</th>
    <th>Products</th>
    <th>Ratio</th>
    <th>Head Count (HC)</th>
    <th>Avg Sale</th>
    <th>Avg Product</th>
  </tr>
)}


{reportName === "Verifier Wise Leader Performance Report" && (
  <tr>
    <th>Leader</th>
    <th>Calls</th>
    <th>Sales</th>
    <th>Conversion (%)</th>
    <th>Products</th>
    <th>Ratio</th>
    <th>Head Count (HC)</th>
    <th>Avg Sale</th>
    <th>Avg Product</th>
  </tr>
)}





              {reportName === "Customer Data" && (
                <tr>
                 <th>CustomerID</th>
                  {/* <th>ID</th> */}
                  <th>First Name</th>
                  <th>Middle Name</th>
                  <th>Last Name</th>
                   <th>DOB</th>
                  <th>Gender</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Alternate Phone</th>
                  <th>Address</th>  
                  <th>City</th>
                  <th>State</th>
                  <th>Zip</th>
                    <th>Card Number</th>
    <th>Expiry</th>   
     <th>CVV</th>
         <th>Bank Name</th>
             <th>Bank Address</th>
                 <th>Routing Number</th>
                     <th>Account Number</th>
                  <th>Lead Source</th>
                  <th>Product</th>
                  <th>Verifier EmpCode</th>
                  <th>Verifier Name</th>
                   <th>VerifCode</th>
                    <th>Track Id</th>
                  <th>Center Name</th>
                  <th>Agent Name</th>
                  <th>Campaign</th>
                  <th>Disposition</th>
                  <th>Comments</th>
                  <th>Sale Date</th>
                   <th>Submitted Date</th>
                  
                </tr>
              )}
            </thead>

            <tbody>
           {reportData.length === 0 ? (
  <tr>
    <td
      colSpan={
        reportName === "Verif Product Report"
          ? products.length + 6
          : reportName === "Center Product Report"
          ? products.length + 5
          : reportName === "Verif Sales Report"
          ? 6
          : reportName === "Customer Data"
          ? 33
          : reportName === "Agent Wise Center Sales Performance Report"
          ? 9   // ✅ 9 columns
           : reportName === "Verifier Wise Center Sales Performance Report"
          ? 9  // ✅ 9 columns here
          : reportName === "Agent Wise Leader Performance Report"
          ? 9
          :reportName === "Verifier Wise Leader Performance Report"
           ? 9
          : 3
          
      }
      style={{ textAlign: "center" }}
    >
      No data found
                  </td>
                </tr>
              ) : (
                reportData.map((row, idx) => {
                  if (reportName === "Agent Sales Report") {
                    return (
                      <tr key={idx}>
                       <td>{row.agentName}</td>
      <td>{row.call}</td>
      <td>{row.sales}</td>
      <td>{row.conv}%</td>
      <td>{row.products}</td>
      <td>{row.ratio}</td>
                      </tr>
                    );
                  } else if (reportName === "Verif Sales Report") {
                    return (
                      <tr key={idx}>
                        <td>{row.empCode}</td>
    <td>{row.verifName}</td>
    <td>{row.transfer}</td>
    <td>{row.sales}</td>
    <td>{row.conv}%</td>
    <td>{row.products}</td>
    <td>{row.ratio}</td>
                      </tr>
                    );
                  } else if (reportName === "Verif Product Report") {
                    return (
                      <tr key={idx}>
                        <td>{row.empCode}</td>
    <td>{row.fullName}</td>
    {products.map((p) => (
      <td key={p._id}>
        {row.productCounts?.[p.productName] || 0}
      </td>
    ))}
    <td>{row.totalProduct}</td>
    <td>{row.totalSale}</td>
    <td>{row.productCon}%</td>
    <td>{row.ratio}</td> {/* ➕ New field */}
                      </tr>
                    );
                  } 
                  else if (reportName === "Center Product Report") {
  return (
    <tr key={idx}>
      {/* ✅ Center Name column */}
      <td>{row.centerName}</td>

      {/* ✅ Dynamic product columns */}
      {products.map((p) => (
        <td key={p._id}>
          {row.productCounts?.[p.productName] || 0}
        </td>
      ))}

      {/* ✅ Totals and ratios */}
      <td>{row.totalProduct}</td>
      <td>{row.totalSale}</td>
      <td>{row.productCon}%</td>
      <td>{row.ratio}</td>
    </tr>
  );
}

 else if (reportName === "Agent Wise Center Sales Performance Report") {
  return (
    <tr key={idx}>
      <td>{row.centerName}</td>
      <td>{row.calls}</td>
      <td>{row.sales}</td>
      <td>{row.conv}%</td>
      <td>{row.products}</td>
      <td>{row.ratio}</td>
      <td>{row.headCount}</td>
      <td>{row.avgSale}</td>
      <td>{row.avgProduct}</td>
    </tr>
  );
}


 else if (reportName === "Verifier Wise Center Sales Performance Report") {
  return (
    <tr key={idx}>
       <td>{row.centerName}</td>
      <td>{row.calls}</td>
      <td>{row.sales}</td>
      <td>{row.conv}%</td>
      <td>{row.products}</td>
      <td>{row.ratio}</td>
      <td>{row.headCount}</td>
      <td>{row.avgSale}</td>
      <td>{row.avgProduct}</td>
    </tr>
  );
}

                else if (reportName === "Agent Wise Leader Performance Report") {
  return (
   <tr key={idx}>
      <td>{row.leader}</td>
      <td>{row.calls}</td>
      <td>{row.sales}</td>
      <td>{row.conv}%</td>
      <td>{row.products}</td>
      <td>{row.ratio}</td>
      <td>{row.headCount}</td>
      <td>{row.avgSale}</td>
      <td>{row.avgProduct}</td>
    </tr>
  );
}   

else if (reportName === "Verifier Wise Leader Performance Report") {
  return (
   <tr key={idx}>
      <td>{row.leader}</td>
      <td>{row.calls}</td>
      <td>{row.sales}</td>
      <td>{row.conv}%</td>
      <td>{row.products}</td>
      <td>{row.ratio}</td>
      <td>{row.headCount}</td>
      <td>{row.avgSale}</td>
      <td>{row.avgProduct}</td>
    </tr>
  );
}   

                  
                  else if (reportName === "Customer Data") {
                    const v = row.transferredVerifier || {};
                    return (
                      <tr key={idx}>
                        {/* <td>{row._id}</td> */}
                        <td>{row.CustomerID}</td>
                        <td>{row.firstName}</td>
                        <td>{row.middleName}</td>
                        <td>{row.lastName}</td>
                           <td>{row.dob}</td>
                        <td>{row.gender}</td>
                        <td>{row.email}</td>
                        <td>{row.phone}</td>
                        <td>{row.alternatePhone}</td>
                        <td>{row.address}</td>
                        <td>{row.city}</td>
                        <td>{row.state}</td>
                        <td>{row.zip}</td>
                           <td>{row.cardNumber}</td>
                           <td>{row.expiry}</td>
                           <td>{row.cvv}</td>
                           <td>{row.bankName}</td>
                           <td>{row.bankAddress}</td>
                             <td>{row.routingNumber}</td>
                               <td>{row.accountNumber}</td>
                        <td>{row.leadSource}</td>
                        <td>{row.product}</td>
                        <td>{v.empCode}</td>
                        <td>{`${v.firstName || ""} ${v.lastName || ""}`}</td>
                    
                             <td>{row.verifCode}</td>
                                  <td>{row.trackId}</td>
                        <td>{row.centerName}</td>
                        <td>{row.agentName}</td>
                        <td>{row.campaign}</td>
                        <td>{row.disposition}</td>
                        <td>{row.comments}</td>
                       <td>{row.verifiedDate || ""}</td>
<td>{row.submittedDate || ""}</td>

                      </tr>
                    );
                  }
                  return null;
                })
              )}
            </tbody>



            {reportData.length > 0 && (
  <tfoot>
    {(() => {
      const s = getSummary();
      if (!s) return null;

      if (reportName === "Agent Sales Report") {
        return (
          <tr style={{ fontWeight: "bold", background: "#f0f0f0" }}>
            <td>{s.label}</td>
            <td>{s.totalCalls}</td>
            <td>{s.totalSales}</td>
            <td>{s.avgConv}%</td>
            <td>{s.totalProducts}</td>
            <td>{s.avgRatio}</td>
          </tr>
        );
      } 
      else if (reportName === "Verif Sales Report") {
        return (
          <tr style={{ fontWeight: "bold", background: "#f0f0f0" }}>
            <td></td>
            <td>{s.label}</td>
            <td>{s.totalTransfer}</td>
            <td>{s.totalSales}</td>
            <td>{s.avgConv}%</td>
            <td>{s.totalProducts}</td>
            <td>{s.avgRatio}</td>
          </tr>
        );
      }

      else if (reportName === "Verif Product Report") {
  return (
    <tr style={{ fontWeight: "bold", background: "#f0f0f0" }}>
      <td></td>  {/* Emp Code empty */}
      <td>{s.label}</td>

      {/* Dynamic product totals */}
      {products.map((p) => (
        <td key={p._id}>
          {s.productTotals?.[p.productName] || 0}
        </td>
      ))}

      <td>{s.totalProducts}</td>
      <td>{s.totalSale}</td>
      <td>{s.avgConv}%</td>
      <td>{s.avgRatio}</td>
    </tr>
  );
}


      else if (
        reportName === "Agent Wise Center Sales Performance Report" ||
        reportName === "Verifier Wise Center Sales Performance Report" ||
        reportName === "Agent Wise Leader Performance Report" ||
        reportName === "Verifier Wise Leader Performance Report"
      ) {
        return (
          <tr style={{ fontWeight: "bold", background: "#f0f0f0" }}>
            <td>{s.label}</td>
            <td>{s.totalCalls}</td>
            <td>{s.totalSales}</td>
            <td>{s.avgConv}%</td>
            <td>{s.totalProducts}</td>
            <td>{s.avgRatio}</td>
            <td>{s.avgHC}</td>
            <td>{s.avgSale}</td>
            <td>{s.avgProduct}</td>
          </tr>
        );
      }

      return null;
    })()}
  </tfoot>
)}




          </table>
        </div>
      )}
    </div>
  );
};

export default Reports;
